export const API_STATUS = "API_STATUS";
export const GET_UOP = "GET_UOP";
export const UPDATE_UOP = "UPDATE_UOP";
export const DELETE_UOP = "DELETE_UOP";
export const ADD_UOP = "ADD_UOP";
export const META_LIST = "META_LIST";
export const APPROVE_UOP = "APPROVE_UOP";

